import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  // 将整数部分逢三一断
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  return intPartFormat
})

Vue.filter('replaceNewlines', function (input) {
  return input.replace(/\r?\n/g, ' '); // 将换行符替换为单个空格
})

Vue.filter('day', function (dataStr, pattern = 'YYYY-MM-DD') {
  if (dataStr) {
    return moment(dataStr).format(pattern)
  }
  return dataStr
})


Vue.filter('dayFromTimestamp', function (timestamp) {
  // 转换为 Date 对象
  const date = new Date(timestamp);
// 提取日期部分
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 月份从 0 开始计数，所以需要 +1
  const day = date.getDate();
// 格式化日期
  const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  return formattedDate
})

Vue.filter('auditStatus', function (status) {
  if (status == '审核未通过') {
    return '待展期/续贷或退回单'
  }
  return status
})

Vue.filter('rateUnitCn', function (rateUnit) {
    if (!rateUnit) { return '' }
    switch (rateUnit) {
      case 'day':
        return '天'
      case 'month':
        return '月'
      case 'year':
        return '年'
    }
})

Vue.filter('filterHouseAgeText', function (text) {
  return `${text}年`
})

Vue.filter('decorateStatus', function (value) {
  return  {
    '0':'精装修',
    '1': '中等装修',
    '2': '简装修',
    '3': '毛坯',
  }[value]
})


Vue.filter('filterHouseTypeText', function (text) {
  switch (text) {
    case '1' :
      return '共有2人'
    case '0' :
      return '独有'
    case '2' :
      return '共有2人以上'
  }
})

Vue.filter('filterHouseDecorateText', function (text) {
  switch (text) {
    case '0' :
      return '精装修'
    case '1' :
      return '中等装修'
    case '2' :
      return '简装修'
    case '3' :
      return '毛坯'
    case '4' :
      return '豪华'
  }
})

Vue.filter('filterLeaseTypeText', function (text) {
  switch (text) {
    case 'yes' :
      return '是'
    case 'no' :
      return '否'
  }
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('formatMoney1', function (num) {
  return num = (num / 10000).toFixed(1) + '万'
})

Vue.filter('changeMoney', function (num) {
  return num = (num / 10000).toFixed(2) + '万'
})

Vue.filter('changeMoneyLong', function (num) {
  return num = (num / 10000).toFixed(0) + '万'
})

Vue.filter('ellipsis', function (txt) {
  if (!txt) return ''
  if(txt.length >= 6){
    return txt.slice(0,6) + '...'
  }
  return txt
})
